<template>
    <router-link to="/" class="logo">
        <img :src="require('@/assets/images/logo.svg')" alt="Logo">
    </router-link>
</template>

<script>
export default {
    setup() {
        
    },
}
</script>
<style scoped>

</style>